document.addEventListener("DOMContentLoaded", function () {

const slides = document.querySelectorAll(".banner-slide");
const next = document.querySelector(".banner-next");
const prev = document.querySelector(".banner-prev");

let index = 0;

function showSlide(i) {
  slides.forEach(slide => slide.classList.remove("active"));
  slides[i].classList.add("active");
}

next.addEventListener("click", function () {
  index++;
  if (index >= slides.length) {
    index = 0;
  }
  showSlide(index);
});

prev.addEventListener("click", function () {
  index--;
  if (index < 0) {
    index = slides.length - 1;
  }
  showSlide(index);
});

/* autoplay */

setInterval(function () {
  index++;
  if (index >= slides.length) {
    index = 0;
  }
  showSlide(index);
}, 5000);

});




document.addEventListener("DOMContentLoaded", function(){

const brandTrack = document.querySelector(".brand-slider-track");
const brandNext = document.querySelector(".brand-next");
const brandPrev = document.querySelector(".brand-prev");

let scrollAmount = 0;
const scrollStep = 250;

brandNext.addEventListener("click", function(){

scrollAmount += scrollStep;

brandTrack.scrollTo({
left: scrollAmount,
behavior:"smooth"
});

});

brandPrev.addEventListener("click", function(){

scrollAmount -= scrollStep;

if(scrollAmount < 0){
scrollAmount = 0;
}

brandTrack.scrollTo({
left: scrollAmount,
behavior:"smooth"
});

});

});



document.addEventListener("DOMContentLoaded", function(){

const track = document.querySelector(".featured-slider-track");
const next = document.querySelector(".featured-next");
const prev = document.querySelector(".featured-prev");

let scrollAmount = 0;
const scrollStep = 280;

next.addEventListener("click", function(){

scrollAmount += scrollStep;

track.scrollTo({
left: scrollAmount,
behavior: "smooth"
});

});

prev.addEventListener("click", function(){

scrollAmount -= scrollStep;

if(scrollAmount < 0){
scrollAmount = 0;
}

track.scrollTo({
left: scrollAmount,
behavior: "smooth"
});

});

});



document.addEventListener("DOMContentLoaded", function(){

const bestTrack = document.querySelector(".best-slider-track");
const bestNext = document.querySelector(".best-next");
const bestPrev = document.querySelector(".best-prev");

let bestScroll = 0;
const bestStep = 280;

bestNext.addEventListener("click", function(){

bestScroll += bestStep;

bestTrack.scrollTo({
left: bestScroll,
behavior:"smooth"
});

});

bestPrev.addEventListener("click", function(){

bestScroll -= bestStep;

if(bestScroll < 0){
bestScroll = 0;
}

bestTrack.scrollTo({
left: bestScroll,
behavior:"smooth"
});

});

});